import React from 'react'
import { ThemeProvider as SCThemeProvider } from 'styled-components'
import CssBaseline from '@mui/material/CssBaseline'
import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider as MuiStyledEngineProvider,
} from '@mui/material/styles'
import GlobalStyle from '../styles/globalStyle'
import theme from '../styles/theme'

type Props = { children: React.ReactNode }

function ThemeProvider({ children }: Props) {
  return (
    <>
      <CssBaseline />
      <MuiStyledEngineProvider injectFirst>
        <MuiThemeProvider theme={theme}>
          <SCThemeProvider theme={theme}>
            <GlobalStyle />
            {children}
          </SCThemeProvider>
        </MuiThemeProvider>
      </MuiStyledEngineProvider>
    </>
  )
}

export default ThemeProvider
